module.exports = __webpack_public_path__ + "img/light3.b6f53d5f.png";